import { useAuth } from 'hooks/useAuth';
import { FC, useCallback, useContext, useEffect, useState } from 'react';
import { AppContext } from 'templates/AppContextProvider';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { useGetConsentHooks } from 'hooks/U015/useGetConsentHooks';
import MessageModal from 'organisms/MessageModal';
import { PATHS } from 'commons/paths';
import { useNavigate } from 'react-router-dom';
import { TermOfServiceReAgreement } from './U015/TermOfServiceReAgreement';
import { PrivacyNoticeReAgreement } from './U015/PrivacyNoticeReAgreement';

type ConsentDialog = 'terms' | 'privacy' | null;
export const ConsentReAgreement: FC = () => {
  const { isAuthenticated } = useAuth();
  const { currentLang, userId } = useContext(AppContext);
  const { t: tConsent } = useTranslationWithLang('consent');
  const [data, isLoading, err] = useGetConsentHooks(userId, currentLang);
  const navigate = useNavigate();
  const [currentDialog, setCurrentDialog] = useState<ConsentDialog>(null);

  /* エラーメッセージモーダル */
  const [isOpen, setIsOpen] = useState(false);
  /*
   このコンポーネントはルーティングの外側に配置されているため、navigateした後もエラーメッセージモーダルされ続ける
   そのため、開閉の状態は独立したstateで管理する
  */
  useEffect(() => {
    if (err && !isLoading) {
      setIsOpen(true);
    }
  }, [err, isLoading]);
  const handleClose = useCallback(() => {
    setIsOpen(false);
    navigate(PATHS.LOGIN);
  }, [navigate]);

  useEffect(() => {
    if (data) {
      if (data.term_of_service_approved === '1') {
        setCurrentDialog('terms');
      } else if (data.privacy_notice_approved === '1') {
        setCurrentDialog('privacy');
      }
    }
  }, [data]);

  if (isAuthenticated) {
    if (isOpen) {
      return (
        <MessageModal
          message={tConsent('TU015_001')}
          closeLabel={tConsent('TU015_003')}
          onClose={handleClose}
        />
      );
    }
    return (
      <>
        {currentDialog === 'terms' && (
          <TermOfServiceReAgreement
            onComplete={() => {
              if (data?.privacy_notice_approved === '1') {
                setCurrentDialog('privacy');
              } else {
                setCurrentDialog(null);
              }
            }}
          />
        )}
        {currentDialog === 'privacy' && (
          <PrivacyNoticeReAgreement
            onComplete={() => {
              setCurrentDialog(null);
            }}
          />
        )}
      </>
    );
  }
};
